import { z } from "zod";
import { optionalUnlessRequired, requiredText, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  rows: z.number().int().min(2).max(20).default(4),
  maxLength: z.number().int().positive().max(50_000).default(2000),
  showCharacterCounter: z.boolean().default(false),
});

export const textMultiField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "text_multi",
  label: "Long text",
  category: "text",
  icon: "AlignLeft",
  configSchema,
  valueSchema: (config, isRequired) => {
    const base = isRequired ? requiredText() : z.string().trim();
    return optionalUnlessRequired(base.max(config.maxLength), isRequired);
  },
  defaultConfig: { rows: 4, maxLength: 2000, showCharacterCounter: false },
  supportsProfileBinding: true,
  defaultSearchable: true,
  renderHints: { multiline: true },
};
